import { render, staticRenderFns } from "./RightHelp.vue?vue&type=template&id=36ba3096&scoped=true&"
import script from "./RightHelp.vue?vue&type=script&lang=js&"
export * from "./RightHelp.vue?vue&type=script&lang=js&"
import style0 from "./RightHelp.vue?vue&type=style&index=0&id=36ba3096&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ba3096",
  null
  
)

export default component.exports